export default __webpack_public_path__ + "static/media/img2.597eb6a7.jpg";